import tailwindConfig from '../../../../tailwind.config';

type Props = {
  size: number;
  color?: string;
};

const People = ({ size, color }: Props) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.53348 3.375C5.39428 3.375 3.67634 5.15095 3.67634 7.32143C3.67634 9.4919 5.39428 11.2679 7.53348 11.2679C9.67269 11.2679 11.3906 9.4919 11.3906 7.32143C11.3906 5.15095 9.67269 3.375 7.53348 3.375ZM5.07924 7.32143C5.07924 5.91701 6.18684 4.79464 7.53348 4.79464C8.88012 4.79464 9.98772 5.91701 9.98772 7.32143C9.98772 8.72584 8.88012 9.84821 7.53348 9.84821C6.18684 9.84821 5.07924 8.72584 5.07924 7.32143Z"
        fill={color || tailwindConfig.theme.colors.black}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.3359 3.375C14.1594 3.375 12.3984 5.14861 12.3984 7.33209C12.3984 9.51557 14.1594 11.2892 16.3359 11.2892C18.5125 11.2892 20.2734 9.51557 20.2734 7.33209C20.2734 5.14861 18.5125 3.375 16.3359 3.375ZM13.8164 7.33209C13.8164 5.92988 14.9464 4.79664 16.3359 4.79664C17.7255 4.79664 18.8555 5.92988 18.8555 7.33209C18.8555 8.7343 17.7255 9.86754 16.3359 9.86754C14.9464 9.86754 13.8164 8.7343 13.8164 7.33209Z"
        fill={color || tailwindConfig.theme.colors.black}
      />
      <path
        d="M7.53348 12.1607C6.31772 12.1607 4.84152 12.4714 3.65696 13.0995C2.47955 13.7237 1.5 14.7169 1.5 16.1071V19.8304H8.77902V18.4107H2.9029V16.1071C2.9029 15.4913 3.32765 14.8768 4.3081 14.357C5.26764 13.8482 6.51564 13.5804 7.53348 13.5804C8.03309 13.5804 8.81752 13.7462 9.375 13.875L9.57614 13.9215C9.57614 13.9215 9.66439 13.8318 9.72299 13.7764C9.93825 13.573 10.094 13.4481 10.315 13.3025C10.536 13.1568 10.9885 12.8586 10.9885 12.8586L9.99082 12.5286C9.16411 12.284 8.29998 12.1607 7.53348 12.1607Z"
        fill={color || tailwindConfig.theme.colors.black}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.3359 12.1847C15.0945 12.1847 13.5867 12.4958 12.3767 13.1247C11.1757 13.749 10.1719 14.7441 10.1719 16.1418V19.875H22.5V16.1418C22.5 14.7441 21.4961 13.749 20.2952 13.1247C19.0852 12.4958 17.5773 12.1847 16.3359 12.1847ZM13.0294 14.3868C12.0227 14.9101 11.5898 15.5274 11.5898 16.1418V18.4534H21.082V16.1418C21.082 15.5274 20.6492 14.9101 19.6425 14.3868C18.6589 13.8756 17.3797 13.6063 16.3359 13.6063C15.2922 13.6063 14.013 13.8756 13.0294 14.3868Z"
        fill={color || tailwindConfig.theme.colors.black}
      />
    </svg>
  );
};

export default People;
